<template>
    <button v-if="supported" type="button" :class="btn_class" :title="active ? 'Salir de pantalla completa' : 'Pantalla completa'"
        :aria-label="active ? 'Salir de pantalla completa' : 'Pantalla completa'" @click="toggle">
        <i :class="'bi ' + (active ? 'bi-fullscreen-exit' : 'bi-arrows-fullscreen')"></i>
    </button>
</template>

<script>
// Whole-page fullscreen toggle. Follows the browser's real state (the user
// can also leave with Esc / the system back gesture), and renders nothing
// where the page can't go fullscreen at all - notably iPhone Safari, which
// only allows it for <video>.
export function fullscreen_element(){
    return document.fullscreenElement || document.webkitFullscreenElement || null;
}

export function request_fullscreen(elem){
    const request = elem.requestFullscreen || elem.webkitRequestFullscreen;
    if(!request) return Promise.resolve();
    // Older WebKit returns undefined instead of a promise.
    return Promise.resolve(request.call(elem)).catch(() => {});
}

export function exit_fullscreen(){
    const exit = document.exitFullscreen || document.webkitExitFullscreen;
    if(!exit || !fullscreen_element()) return Promise.resolve();
    return Promise.resolve(exit.call(document)).catch(() => {});
}

export function fullscreen_supported(){
    return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled);
}

export default {
    name: 'FullScreen',
    props: {
        btn_class: { type: String, default: 'btn btn-sm btn-outline-light' },
    },
    data(){
        return {
            supported: fullscreen_supported(),
            active: !!fullscreen_element(),
        };
    },
    mounted(){
        document.addEventListener('fullscreenchange', this.sync);
        document.addEventListener('webkitfullscreenchange', this.sync);
    },
    beforeUnmount(){
        document.removeEventListener('fullscreenchange', this.sync);
        document.removeEventListener('webkitfullscreenchange', this.sync);
    },
    methods: {
        sync(){
            this.active = !!fullscreen_element();
            this.$store.commit('setFullScreen', this.active);
        },
        toggle(){
            if(fullscreen_element()) exit_fullscreen();
            else request_fullscreen(document.documentElement);
        }
    }
}
</script>
